import { StaticImport } from "next/dist/shared/lib/get-img-props";
import styles from "@/components/modal/affiliate/styles/affiliate-step.module.scss";
import affiliateStyles from "@/components/modal/affiliate/styles/affiliate-modal.module.scss";
import Image from "next/image";

type AffiliateStepProps = {
  index: number;
  description: string;
  icon: string | StaticImport;
};

const AffiliateStep = ({ index, description, icon }: AffiliateStepProps) => {
  return (
    <div className={styles.step_wrapper}>
      <div className={styles.step_icon_wrapper}>
        <Image alt={""} src={icon} />
      </div>
      <div className={styles.step_text_wrapper}>
        <div className={affiliateStyles.secondary_text}>Step {index}</div>
        <div className={affiliateStyles.details_text}>{description}</div>
      </div>
    </div>
  );
};

export default AffiliateStep;
